import { render, staticRenderFns } from "./WPLayoutInDev.vue?vue&type=template&id=6172bb2a"
import script from "./WPLayoutInDev.vue?vue&type=script&lang=ts"
export * from "./WPLayoutInDev.vue?vue&type=script&lang=ts"
import style0 from "./WPLayoutInDev.vue?vue&type=style&index=0&id=6172bb2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports